import React from 'react';

const OptimalTimingHeatmap = () => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const hours = ['6AM', '9AM', '12PM', '3PM', '6PM', '9PM'];

  // Engagement intensity (0-100)
  const heatmapData = [
    [30, 45, 35, 40, 25, 15], // Mon
    [35, 85, 75, 65, 45, 20], // Tue
    [40, 90, 80, 70, 50, 25], // Wed
    [38, 88, 78, 68, 48, 22], // Thu
    [32, 60, 55, 50, 35, 18], // Fri
    [20, 35, 40, 45, 55, 40], // Sat
    [18, 30, 35, 40, 50, 35]  // Sun
  ];

  const getHeatColor = (value) => {
    if (value >= 80) return 'bg-success';
    if (value >= 60) return 'bg-primary';
    if (value >= 40) return 'bg-accent';
    if (value >= 20) return 'bg-warning/50';
    return 'bg-muted';
  };

  const getHeatIntensity = (value) => {
    if (value >= 80) return 'High';
    if (value >= 60) return 'Good';
    if (value >= 40) return 'Medium';
    if (value >= 20) return 'Low';
    return 'Very Low';
  };

  return (
    <div className="space-y-4">
      {/* Heatmap Grid */}
      <div className="overflow-x-auto">
        <div className="min-w-[500px]">
          {/* Hour labels */}
          <div className="flex items-center mb-2">
            <div className="w-12"></div>
            {hours?.map((hour, index) => (
              <div key={index} className="flex-1 text-center">
                <span className="text-xs font-medium text-muted-foreground">{hour}</span>
              </div>
            ))}
          </div>

          {/* Heatmap rows */}
          {days?.map((day, dayIndex) => (
            <div key={dayIndex} className="flex items-center gap-1 mb-1">
              <div className="w-12">
                <span className="text-xs font-medium text-foreground">{day}</span>
              </div>
              {heatmapData?.[dayIndex]?.map((value, hourIndex) => (
                <div
                  key={hourIndex}
                  className="flex-1 aspect-square rounded-md cursor-pointer transition-all hover:scale-110 hover:shadow-md group relative"
                  title={`${day} ${hours?.[hourIndex]}: ${getHeatIntensity(value)} engagement (${value}%)`}
                >
                  <div className={`w-full h-full rounded-md ${getHeatColor(value)} flex items-center justify-center`}>
                    <span className="text-xs font-semibold text-white opacity-0 group-hover:opacity-100 transition-opacity">
                      {value}%
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Legend */}
      <div className="flex flex-wrap items-center justify-center gap-3 pt-4 border-t border-border">
        <span className="text-xs text-muted-foreground">Engagement Level:</span>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-muted"></div>
          <span className="text-xs text-muted-foreground">Very Low</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-warning/50"></div>
          <span className="text-xs text-muted-foreground">Low</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-accent"></div>
          <span className="text-xs text-muted-foreground">Medium</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-primary"></div>
          <span className="text-xs text-muted-foreground">Good</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-success"></div>
          <span className="text-xs text-muted-foreground">High</span>
        </div>
      </div>

      {/* Best Times Summary */}
      <div className="bg-primary/10 rounded-lg p-3 border border-primary/20">
        <p className="text-sm text-foreground">
          <span className="font-semibold">Best posting times:</span> Tuesday-Thursday, 9-11 AM
          <span className="text-muted-foreground ml-2">(45% higher engagement)</span>
        </p>
      </div>
    </div>
  );
};

export default OptimalTimingHeatmap;